export default {
    getStoredQuickAccesses: (state) => {
        return state.quickAccesses
    },
    getStoredQuickAccessById: state => (id) => {
        return state.quickAccesses.find(e => e.id === id)
    },
    getStoredQuickAccess: state => {
        return state.quickAccess
    },
}
